var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"aria-hidden":"true"}},[_c('loading-busy',{attrs:{"loading":_vm.loading,"isAuthenticating":false,"text":""}}),_c('div',{staticClass:"g-recaptcha",attrs:{"data-size":"invisible","data-sitekey":_vm.googleRecaptchaApiKey,"data-action":_vm.action,"data-callback":"recaptchaCallback"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }